class SortCollection extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', (event) => {
      this.handleChange(event);
    });
  }
  handleChange(event) {
    const value = event.target.value;
    const url = new URL(window.location);
    let params = new URLSearchParams(url.search);
    params.delete('sort_by');

    if (value != '') {
      params.set('sort_by', value);
      // Dynamically find the CollectionFiltersForm instance
      const collectionFiltersForm = document.querySelector('product-filters-form');
      collectionFiltersForm?.renderPage(params.toString());
    }
  }
}
customElements.define('sort-collection', SortCollection);
